import TableJs from '@/utils/Table'

export default {
  countCells: 4,
  table_1: [
    {
      dataField: 'mmm',
      cols: 5,
      rows: 1,
      text: '',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9; background: unset; border-top: 1px solid #b7ced9; ; border-left: 1px solid #b7ced9;`,
      variable: false,
      // template: (r) => r?.id
    },
    {
      dataField: 'mmm2',
      cols: 1,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; align-items: center; justify-content: center; background: unset; border-top: 1px solid #b7ced9;`,
      variable: false,
      styles: ``,
      text: `...`,
    },
    {
      dataField: 'mmm1',
      cols: 6,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; align-items: center; padding: 5px 10px; background: unset; border-top: 1px solid #b7ced9;`,
      variable: false,
      text: `Обучающихся (искл. квоту иностр.граждан) на&nbsp;01.10.2023&nbsp;г.`,
    },
    {
      dataField: 'mmm3',
      cols: 6,
      rows: 1,
      class: `justify-center`,
      headerStyles: `align-items: center;  padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9; border-top: 1px solid #b7ced9;`,
      styles: ``,
      variable: false,
      text: `Иностр.граждан, обучающихся по квоте на&nbsp;01.10.2023&nbsp;г.`,
    },
    {
      dataField: 'column_1_2',
      cols: 5,
      rows: 1,
      text: 'Уровни образования',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9;  padding: 5px 10px; background: unset; border-left: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9',
      variable: false,
      // template: (r) => r?.id
    },
    {
      dataField: 'column_6',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset `,
      styles: 'border-right: 1px solid #b7ced9',
      text: `...`,
    },
    {
      dataField: 'column_3',
      cols: 2,
      rows: 1,
      text: 'очно',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9',
      variable: false,
    },
    {
      dataField: 'column_4',
      cols: 2,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно-заочно`,
    },
    {
      dataField: 'column_5',
      cols: 2,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `заочно`,
    },
    {
      dataField: 'column_7',
      cols: 2,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно`,
    },
    {
      dataField: 'column_8',
      cols: 2,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно-заочно`,
    },
    {
      dataField: 'column_9',
      cols: 2,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `justify-content: center;   padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9;`,
      styles: '',
      text: `заочно`,
    },
    {
      dataField: 'bsm',
      variable: true,
      cols: 5,
      rows: 1,
      text: '1, 2',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'border-left: 1px solid #b7ced9; color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return `<span style="font-weight: 700">${r.bsm}</span>`
        } else {
          return r.bsm
        }
      }
    },
    {
      dataField: 'xxx',
      cols: 1,
      rows: 1,
      text: `...`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
    },
    {
      dataField: 'nb20',
      variable: true,
      cols: 2,
      rows: 1,
      text: '6',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'justify-content: unset; color: black'
        } else {
          return 'justify-content: unset; border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb20, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nb21',
      cols: 2,
      rows: 1,
      text: `7`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb21, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nb22',
      cols: 2,
      rows: 1,
      variable: true,
      text: `8`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb22, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq20',
      cols: 2,
      rows: 1,
      text: `9`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq20, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq21',
      cols: 2,
      rows: 1,
      variable: true,
      text: `10`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq21, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq22',
      cols: 2,
      rows: 1,
      variable: true,
      text: `11`,
      class: `justify-center`,
      headerStyles: `justify-content: center;  padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq22, 0, 'integer')
        }
      }
    },
  ],

  table_2: [
    {
      dataField: 'mmm',
      cols: 3,
      rows: 1,
      text: 'Всего обучающихся',
      class: 'd-flex align-center',
      headerStyles: `background: unset`,
      variable: false,
    },
    {
      dataField: 'column_1',
      cols: 1,
      rows: 1,
      text: 'очно',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9',
      variable: false,
    },
    {
      dataField: 'column_2',
      cols: 1,
      rows: 1,
      text: `очно-заочно`,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
    },
    {
      dataField: 'column_3',
      cols: 1,
      rows: 1,
      text: `заочно`,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
    },
    {
      dataField: 'no20',
      cols: 1,
      rows: 1,
      text: 'гр.6 + гр.9',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'justify-content: unset; color: black'
        } else {
          return 'justify-content: unset; border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; color: black'
        }
      },
      variable: true,
    },
    {
      dataField: 'no21',
      cols: 1,
      rows: 1,
      text: `гр.7 + гр.10`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
    },
    {
      dataField: 'no22',
      cols: 1,
      rows: 1,
      variable: true,
      text: `гр.8 + гр.11`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
    },
  ],

  table_2_2: [
    {
      dataField: 'mmm',
      cols: 2,
      rows: 1,
      text: 'Прошедших обучение по очной форме',
      class: 'd-flex align-center',
      headerStyles: `background: unset`,
      variable: false,
    },
    {
      dataField: 'column_1',
      cols: 1,
      rows: 1,
      text: 'по программам повышения квалификации',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9',
      variable: false,
    },
    {
      dataField: 'column_2',
      cols: 1,
      rows: 1,
      text: `по программам профессиональной переподготовки`,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
    },
    {
      dataField: 'no20',
      cols: 1,
      rows: 1,
      text: 'гр.3 - гр.4 - гр.5',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; color: black',
      variable: true,
    },
    {
      dataField: 'no21',
      cols: 1,
      rows: 1,
      text: `гр.6 - гр.7 - гр.8`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
    },
  ],

  table_3: [
    {
      dataField: 'mmm',
      cols: 11,
      rows: 1,
      text: '',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9; background: unset; border-top: 1px solid #b7ced9; ; border-left: 1px solid #b7ced9;`,
      variable: false,
      // template: (r) => r?.id
    },
    {
      dataField: 'mmm2',
      cols: 1,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; align-items: center; justify-content: center; background: unset; border-top: 1px solid #b7ced9;`,
      variable: false,
      styles: ``,
      text: `...`,
    },
    {
      dataField: 'mmm1',
      cols: 3,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; align-items: center; padding: 5px 10px; background: unset; border-top: 1px solid #b7ced9; min-width: 250px`,
      variable: false,
      text: `Обучающихся (искл. квоту иностр.граждан) на&nbsp;01.10.2023&nbsp;г.`,
    },
    {
      dataField: 'mmm3',
      cols: 3,
      rows: 1,
      class: `justify-center`,
      headerStyles: `align-items: center;  padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9; border-top: 1px solid #b7ced9; min-width: 250px`,
      styles: ``,
      variable: false,
      text: `Иностр.граждан, обучающихся по квоте на&nbsp;01.10.2023&nbsp;г.`,
    },
    {
      dataField: 'column_1_2',
      cols: 11,
      rows: 1,
      text: 'Уровни образования',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9;  padding: 5px 10px; background: unset; border-left: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9',
      variable: false,
      // template: (r) => r?.id
    },
    {
      dataField: 'column_6',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset `,
      styles: 'border-right: 1px solid #b7ced9',
      text: `...`,
    },
    {
      dataField: 'column_3',
      cols: 1,
      rows: 1,
      text: 'очно',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9',
      variable: false,
    },
    {
      dataField: 'column_4',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно-заочно`,
    },
    {
      dataField: 'column_5',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `заочно`,
    },
    {
      dataField: 'column_7',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно`,
    },
    {
      dataField: 'column_8',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно-заочно`,
    },
    {
      dataField: 'column_9',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `justify-content: center;   padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9;`,
      styles: '',
      text: `заочно`,
    },
    {
      dataField: 'bsm',
      variable: true,
      cols: 11,
      rows: 1,
      text: '1, 2',
      class: `p-0 pl-3`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'border-left: 1px solid #b7ced9; color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return `<span style="font-weight: 700">${r.bsm}</span>`
        } else {
          return r.bsm
        }
      }
    },
    {
      dataField: 'xxx',
      cols: 1,
      rows: 1,
      text: `...`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
    },
    {
      dataField: 'nb20',
      variable: true,
      cols: 1,
      rows: 1,
      text: '6',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'justify-content: unset; color: black'
        } else {
          return 'justify-content: unset; border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb20, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nb21',
      cols: 1,
      rows: 1,
      text: `7`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb21, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nb22',
      cols: 1,
      rows: 1,
      variable: true,
      text: `8`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb22, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq20',
      cols: 1,
      rows: 1,
      text: `9`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq20, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq21',
      cols: 1,
      rows: 1,
      variable: true,
      text: `10`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq21, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq22',
      cols: 1,
      rows: 1,
      variable: true,
      text: `11`,
      class: `justify-center`,
      headerStyles: `justify-content: center;  padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq22, 0, 'integer')
        }
      }
    },
  ],

  table_3_1: [
    {
      dataField: 'mmm',
      cols: 11,
      rows: 1,
      text: '',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9; background: unset; border-top: 1px solid #b7ced9; ; border-left: 1px solid #b7ced9;`,
      variable: false,
      // template: (r) => r?.id
    },
    {
      dataField: 'mmm2',
      cols: 1,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; align-items: center; justify-content: center; background: unset; border-top: 1px solid #b7ced9;`,
      variable: false,
      styles: ``,
      text: `...`,
    },
    {
      dataField: 'mmm1',
      cols: 3,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; align-items: center; padding: 5px 10px; background: unset; border-top: 1px solid #b7ced9; min-width: 250px`,
      variable: false,
      text: `Обучающихся (искл. квоту иностр.граждан) на&nbsp;01.10.2024&nbsp;г.`,
    },
    {
      dataField: 'mmm3',
      cols: 3,
      rows: 1,
      class: `justify-center`,
      headerStyles: `align-items: center;  padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9; border-top: 1px solid #b7ced9; min-width: 250px`,
      styles: ``,
      variable: false,
      text: `Иностр.граждан, обучающихся по квоте на&nbsp;01.10.2024&nbsp;г.`,
    },
    {
      dataField: 'column_1_2',
      cols: 11,
      rows: 1,
      text: 'Уровни образования',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9;  padding: 5px 10px; background: unset; border-left: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9',
      variable: false,
      // template: (r) => r?.id
    },
    {
      dataField: 'column_6',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset `,
      styles: 'border-right: 1px solid #b7ced9',
      text: `...`,
    },
    {
      dataField: 'column_3',
      cols: 1,
      rows: 1,
      text: 'очно',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9',
      variable: false,
    },
    {
      dataField: 'column_4',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно-заочно`,
    },
    {
      dataField: 'column_5',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `заочно`,
    },
    {
      dataField: 'column_7',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно`,
    },
    {
      dataField: 'column_8',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно-заочно`,
    },
    {
      dataField: 'column_9',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `justify-content: center;   padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9;`,
      styles: '',
      text: `заочно`,
    },
    {
      dataField: 'bsm',
      variable: true,
      cols: 11,
      rows: 1,
      text: '1, 2',
      class: `p-0 pl-3`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'border-left: 1px solid #b7ced9; color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return `<span style="font-weight: 700">${r.bsm}</span>`
        } else {
          return r.bsm
        }
      }
    },
    {
      dataField: 'xxx',
      cols: 1,
      rows: 1,
      text: `...`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
    },
    {
      dataField: 'nb20',
      variable: true,
      cols: 1,
      rows: 1,
      text: '6',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'justify-content: unset; color: black'
        } else {
          return 'justify-content: unset; border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb20, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nb21',
      cols: 1,
      rows: 1,
      text: `7`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb21, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nb22',
      cols: 1,
      rows: 1,
      variable: true,
      text: `8`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb22, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq20',
      cols: 1,
      rows: 1,
      text: `9`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq20, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq21',
      cols: 1,
      rows: 1,
      variable: true,
      text: `10`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq21, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq22',
      cols: 1,
      rows: 1,
      variable: true,
      text: `11`,
      class: `justify-center`,
      headerStyles: `justify-content: center;  padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq22, 0, 'integer')
        }
      }
    },
  ],

  table_4: [
    {
      dataField: 'mmm',
      cols: 11,
      rows: 1,
      text: '',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9; background: unset; border-top: 1px solid #b7ced9; ; border-left: 1px solid #b7ced9;`,
      variable: false,
    },
    {
      dataField: 'mmm1',
      cols: 3,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; align-items: center; padding: 5px 10px; background: unset; border-top: 1px solid #b7ced9; min-width: 250px`,
      variable: false,
      text: `по&nbsp;программам повышения квалификации в&nbsp;2023&nbsp;г.`,
    },
    {
      dataField: 'mmm3',
      cols: 3,
      rows: 1,
      class: `justify-center`,
      headerStyles: `align-items: center;  padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9; border-top: 1px solid #b7ced9; min-width: 250px`,
      styles: ``,
      variable: false,
      text: `по&nbsp;программам профессиональной переподготовки в&nbsp;2023&nbsp;г.`,
    },
    {
      dataField: 'column_1_2',
      cols: 11,
      rows: 1,
      text: 'Виды экономической деятельности (по разделам ОКВЭД)',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9;  padding: 5px 10px; background: unset; border-left: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9',
      variable: false,
    },
    {
      dataField: 'column_3',
      cols: 1,
      rows: 1,
      text: 'все формы',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9',
      variable: false,
    },
    {
      dataField: 'column_4',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно-заочно`,
    },
    {
      dataField: 'column_5',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `заочно`,
    },
    {
      dataField: 'column_7',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `все формы`,
    },
    {
      dataField: 'column_8',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `очно-заочно`,
    },
    {
      dataField: 'column_9',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `justify-content: center;   padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9;`,
      styles: '',
      text: `заочно`,
    },
    {
      dataField: 'bsm',
      variable: true,
      cols: 11,
      rows: 1,
      text: '1, 2',
      class: `p-0 pl-3`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'border-left: 1px solid #b7ced9; color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return `<span style="font-weight: 700">${r.bsm}</span>`
        } else {
          return r.bsm
        }
      }
    },
    {
      dataField: 'nb20',
      variable: true,
      cols: 1,
      rows: 1,
      text: '3',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset; min-width: 100px`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'justify-content: unset; color: black'
        } else {
          return 'justify-content: unset; border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb20, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nb21',
      cols: 1,
      rows: 1,
      text: `4`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset; min-width: 100px`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb21, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nb22',
      cols: 1,
      rows: 1,
      variable: true,
      text: `5`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nb22, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq20',
      cols: 1,
      rows: 1,
      text: `6`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset; min-width: 100px`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq20, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq21',
      cols: 1,
      rows: 1,
      variable: true,
      text: `7`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset; min-width: 100px`,
      styles: (r) => {
        if (r.isUgtxt) {
          return 'color: black'
        } else {
          return 'border-right: 1px solid #b7ced9; color: black'
        }
      },
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq21, 0, 'integer')
        }
      }
    },
    {
      dataField: 'nq22',
      cols: 1,
      rows: 1,
      variable: true,
      text: `8`,
      class: `justify-center`,
      headerStyles: `justify-content: center;  padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
      template: (r) => {
        if (r.isUgtxt) {
          return ``
        } else {
          return TableJs.checkValueWithNullAndReturnND(r.nq22, 0, 'integer')
        }
      }
    },
  ],
}